"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECT_MENU_WIDTH = exports.MAX_OPTION_SIZE = exports.ASSOC_STORE_SEARCH_MAX = void 0;
var ASSOC_STORE_SEARCH_MAX = 5;
exports.ASSOC_STORE_SEARCH_MAX = ASSOC_STORE_SEARCH_MAX;
var MAX_OPTION_SIZE = 50;
exports.MAX_OPTION_SIZE = MAX_OPTION_SIZE;
var SELECT_MENU_WIDTH = 345;
exports.SELECT_MENU_WIDTH = SELECT_MENU_WIDTH;